import { getServicePathToAPI, joinURLPath } from '@sigma-frontend-libs/commons'

import { generateServices, globalErrorHandler, permissionPresets, proxy, request, services } from '@/utils'

import render from './render'

const pathToAPI = getServicePathToAPI(services['otp-settings/widgets'])
const serviceNameViaPoint = services['otp-settings/widgets'].split('/').join('.')

export default {
  name: 'SecondCol',

  mixins: [
    proxy({ type: 'object' }),

    generateServices({
      name: services['otp-settings/channels'],

      backendGeneration: 'nest',

      get: false,
      create: false,
      update: false,
      remove: false
    })
  ],

  data() {
    return {
      tab: undefined,
      loading: false
    }
  },

  computed: {
    filteredChannels() {
      return this.proxy.otpWidgetChannelSettings.filter(({ otpChannelSettingsId, priority }) => {
        if (otpChannelSettingsId && typeof priority === 'number') {
          return {
            otpChannelSettingsId,
            priority
          }
        }
      })
    },

    hasPermissions() {
      return this.checkPermissions(`advanced.${serviceNameViaPoint}.get`, permissionPresets.meUp)
    },

    tabs() {
      const result = []
      if (this.hasPermissions) {
        result.push('channels')
      }

      return result.map(key => {
        return {
          key,
          title: this.getTranslate(`commons.tabs.${key}`)
        }
      })
    }
  },

  mounted() {
    this.tab = this.tabs[0]?.key
    this.rest[services['otp-settings/channels']].find()
  },

  methods: {
    async attachChannels() {
      try {
        this.loading = true
        const data = await request.update(
          joinURLPath(pathToAPI, this.$route.params.id, 'channels', 'bulk'),
          { body: { otpWidgetChannelSettings: this.filteredChannels } }
        )
        if (data) {
          this.addSnackbar({
            text: this.getTranslate(`${serviceNameViaPoint}.snackbars.channels.attached`),
            type: 'success'
          })
        }
      } catch (error) {
        globalErrorHandler(error)
      } finally {
        this.loading = false
      }
    }
  },

  render
}
